import { Colors } from 'baseStyles/enums/colors';
import React from 'react';
import Styled from 'styled-components'

const computeValue = (value: number | string) => {
  if(typeof value === "number") {
      return `${value || 0}px`;
  }
  return value;
}

type ImagePropsType = {
    src?: string;
    alt?: string;
    width?: string | number;
    height?: string | number;
    autoDimensions?: boolean;
    borderRadius?: string;
    objectFit?: string;
}

const ContainerImage = Styled.img<ImagePropsType>`
    /* background-color: ${Colors.LIGHT_GREY_2}; */
    width: ${props => computeValue(props.width) || 'inherit'};
    height: ${props => computeValue(props.height) || 'inherit'};
    ${props => props?.autoDimensions && `
      height: auto;
      width: auto;  
    `}
    ${props => props?.objectFit && `
        object-fit: ${props?.objectFit};
    `}
    ${props => props?.borderRadius && `
        border-radius: ${props?.borderRadius};
    `}
`;

const Image: React.VFC<ImagePropsType> = React.memo(({ src, alt, autoDimensions = false, objectFit = "", ...props }) => {
  // if (typeof src === "undefined") return null;
  return (
    <ContainerImage src={src} alt={alt} autoDimensions={autoDimensions} loading="lazy" {...props} />)
})

export default Image;